import { ArrowDown, ArrowUpRight } from "lucide-react";
import { Reveal, ActionLink, ScrollDepth, useSceneActivity } from "./ui";
import { QuantumField } from "./quantum-field";

export function Hero() {
  const { ref, active } = useSceneActivity();
  return (
    <section
      ref={ref}
      data-running={active}
      className="hero"
      id="home"
      aria-labelledby="hero-title"
    >
      <div className="wrap hero-content">
        <div className="hero-composition">
          <div className="hero-copy">
            <Reveal className="hero-kicker">
              <span />
              Software consulting &amp; development
            </Reveal>
            <Reveal delay={0.08}>
              <h1 id="hero-title">
                Software built
                <br />
                around your
                <br />
                <span>business.</span>
              </h1>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="hero-description">
                We're a software consulting and development firm building web
                apps and custom platforms. We use AI-assisted development to
                move faster and integrate AI into business tools where it adds
                value.
              </p>
            </Reveal>
            <Reveal delay={0.24} className="hero-actions">
              <ActionLink className="primary-button">
                Discuss a project
              </ActionLink>
              <a className="secondary-button" href="#services">
                Our services
                <ArrowUpRight size={17} />
              </a>
            </Reveal>
          </div>
          <ScrollDepth className="hero-depth" distance={24}>
            <QuantumField />
          </ScrollDepth>
        </div>
        <div className="hero-bottom">
          <span>CUSTOM SOFTWARE SOLUTIONS</span>
          <a href="#learn-more" aria-label="Explore our approach">
            <ArrowDown size={17} />
          </a>
          <span>TORONTO, ONTARIO</span>
        </div>
      </div>
    </section>
  );
}
